import React, { useEffect, useState } from "react";
import MaterialTable from "material-table";
import EditIcon from "@material-ui/icons/Edit";
import VisibilityIcon from "@material-ui/icons/Visibility";
import { DateRange } from "react-date-range";
import moment from "moment";
import DataService from "../../../../../Service";
import Typography from "@material-ui/core/Typography";
import Popover from "@material-ui/core/Popover";
import { useHistory } from "react-router";
import {  useLocation } from "react-router-dom";
import { BASE_URL } from "../../../../../constants.tsx";

import {
  makeStyles,
  Button,
  ThemeProvider,
  MenuItem,
  Select,
} from "@material-ui/core";
import Grid from "@material-ui/core/Grid";
import CustomSelect from "../../../../../Components/CustomSelect";
import Box from "@material-ui/core/Box";
import { useSelector, useDispatch } from "react-redux";
import Autocomplete from "@material-ui/lab/Autocomplete";
import TextField from "@material-ui/core/TextField";
import { Divider, Link } from "@material-ui/core";
import Loader from "../../../../../Components/Loader";
import { fontTheme } from "../../../../../fontTheme";
import useDebounce from "../../../../../Components/debounce";
import {
  TableContainer,
  Table,
  TableBody,
  TableHead,
  TableRow,
  TableCell,
  TablePagination,
} from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  // wrapper: {
  //   // padding: "5%",
  //   paddingTop: '0px',
  //   "& .MuiTouchRipple-root": {
  //     position: "relative"
  //   }
  // },
  tableWrapper: {
    padding: "5%",
  },
  datepickerPopover: {
    textAlign: "right",
    marginTop: "33px",
    "& button": {
      backgroundColor: "#ffffff",
      border: "1px solid #d7dae2",
      textTransform: "capitalize",
      "&:hover": {
        backgroundColor: "#ffffff",
      },
    },
  },
  title: {
    fontSize: theme.spacing(3),
    fontWeight: 700,
    padding: theme.spacing(2),
  },
  subTitle: {
    fontSize: theme.spacing(2),
    fontWeight: 500,
  },
  customTextField: {
    "& .MuiTabs-flexContainer": {
      justifyContent: "flex-start",
    },
    '& .MuiAutocomplete-inputRoot[class*="MuiOutlinedInput-root"]': {
      padding: "0px",
    },
    "& .MuiTabs-indicator": {
      backgroundColor: "transparent",
    },
  },
  paper: {
    boxShadow:
      "0px 3px 1px -2px rgba(0,0,0,0.2), 0px 2px 2px 0px rgba(0,0,0,0.14), 0px 1px 5px 0px rgba(0,0,0,0.12)",
    minHeight: "200px",
  },
  detailWrap: {
    padding: "20px",
  },
  wrapper1: {
    backgroundColor: "#fff",
    borderRadius: "4px",
    padding: theme.spacing(1, 2),
    border: "1px solid #d5d5d5",
    marginLeft: "73px",
    marginBottom: "30px",
    paddingLeft: "2px",
    paddingTop: "3px",
    paddingBottom: "8px",
    width: "32%",
    height: "40px",
  },
  root: {
    borderBottom: "none !important",
    fontSize: "16px",
    fontFamily: "Open Sans",
  },
  container: {
    maxHeight: 440,
  },
  actions: {
    borderBottom: "none !important",
    color: "green",
  },
  buttonShadow: {
    textTransform: "inherit",
    fontWeight: "normal",

    "&:hover": {
      "background-color": "none !important",
    },
  },
}));

export default function CoachRateCard(props) {
  const classes = useStyles();
  const [currentSelection, setCurrentSelection] = useState({});
  const [CoachinRates, setModuleSetups] = useState([]);
  const [action, setAction] = useState(null);
  const [modules, setModules] = useState(null);
  const [loading, setLoading] = useState(false);
  const [totalCount, setTotalCount] = useState(100);
  const [searchText, setSearchText] = useState("");
  const [searchTextSelect, handleSearchText] = useState(null);
  const debouncedSearchText = useDebounce(searchTextSelect, 700);
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(20);
  const [openPopover, setPopover] = useState(null);
  const [anchorEl, setAnchorEl] = useState(null);
  const [refresh, setRefresh] = useState(false);
  const [value, setValue] = React.useState("");
  const [inputValue, setInputValue] = React.useState("");
  const [orgValue, setOrgValue] = React.useState("");
  const [inputValue1, setInputValue1] = React.useState("");
  const [inputValue2, setInputValue2] = React.useState("");
  const [inputValue3, setInputValue3] = React.useState("");
  const [open, setOpen] = useState(false);
  const anchorRef = React.useRef(null);
  const [anchorElPicker, setAnchorElPicker] = useState(null);
  const [filterDataState, setFilterDataState] = useState([
    {
      startDate: null,
      endDate: null,
      key: "selection",
    },
  ]);
  const history = useHistory();
  const location1 = useLocation();
const path = location1.pathname;
sessionStorage.setItem("pathname", path);

  const [organizationLoader, setOrganizationLoader] = useState(false);
  const columns = [
    {
      label: "Organizational metric",
      id: "organisation_metric",
    },
    {
      label: "Objective no",
      id: "objective",
    },
    {
      label: "Description of objective",
      id: "description_of_objective",
    },
    {
      label: "What will you do to get there?",
      id: "what_will_you_do_to_get_there",
    },
    {
      label: "Business impact",
      id: "business_impact",
    },
    {
      label: "Measurement metrics",
      id: "measurement_metrics",
    },
    {
      label: "Percentage completion",
      id: "percentage_completion",
    },
    {
      label: "Evidence/Comments",
      id: "evidence_comments",
    },
    {
      label: "View summary",
      id: "view_summary",
      render: (rowData) => {
        return (
          <>
            <Button
              disableElevation
              onClick={() => {
              

                props.history.push({
                  pathname: "/assignmentoverview",
                  state: {
                    currentAssignment: {
                      id: currentSelection?.id,
                      name: currentSelection?.value,
                    },
                  },
                });
                props?.handleClose();
              }}
              variant="outlined"
            >
              Go to assignment overview page
            </Button>
            {/* <a href={`${BASE_URL}${rowData.link}`} target="_blank" download rel="noopener noreferrer">{`${BASE_URL}${rowData.link}`.split("/").pop()}</a> */}
          </>
        );
      },
    },
  ];
  const [orgData, setOrgData] = useState([]);
  const [CAFList, setCAFList] = useState([]);
  const [businessUnit, setBusinessUnit] = useState([]);
  const [serviceType, setServiceType] = useState([]);
  const [location, setLocation] = useState([]);
  const [CAFDate, setCAFDate] = useState([]);
  const getData = () => {
    setLoading(true);

    DataService.getDirectData(`/organisations`)
      .then((response) => {
        var localArr = [
          {
            id: null,
            org_id: null,
            organisation_name: "All",
            internal_status: "All",
          },
          ...response.organisations,
        ];
        setOrgData(orgData.concat(localArr));
        setLoading(false);
      })
      .catch((err) => {});
  };
  useEffect(() => {
    setLoading(true);
    getData();
  }, []);
  const data = {
    filter: "",
    from_date: "",
    end_date: "",
    sort_by: "",
    business_unit_id: "",
    location_id: "",
    service_type: "",
    service_type_id:"",
  };

  const [userData, setUserData] = useState(data);
  const CoachinRate = () => {
    if (role === "admin") {
      const params = {
        organisation_id: value.id,
        page: page + 1 || 1,
        count_per_page: pageSize || 20,
      };
      DataService.getDirectData(
        `/coaching_agreement_forms/collate_objective`,
        params
      ).then((res) => {
        setTotalCount(res["total_count"]);
        let CoachinRates = res.collate_objective;
        setCAFList(CoachinRates);

        setLoading(false);
      });
    } else {
      DataService.getDirectData(
        `/coaching_agreement_forms/listing_dropdowns`
      ).then((res) => {
        setBusinessUnit(res.business_unit);
        setServiceType(res.service_type)
        setLocation(res.location);
      });

      const params = {
        // organisation_id: value.id,
        from_date:
          filterDataState[0].startDate == null ||
          userData.filter !== "Custom date"
            ? ""
            : moment(filterDataState[0].startDate).format("DD-MM-YYYY"),
        end_date:
          filterDataState[0].endDate == null ||
          userData.filter !== "Custom date"
            ? ""
            : moment(filterDataState[0].endDate).format("DD-MM-YYYY"),
        filter:
          // (filterDataState[0].startDate !== null || filterDataState[0].endDate == null ) ? "" :
          userData.filter,
        sort_by: userData.sort_by,
        business_unit_id: userData.business_unit_id,
        location_id: userData.location_id,
        service_type: userData.service_type,
        service_type_id: userData.service_type_id,
      };
      DataService.getDirectData(
        `/coaching_agreement_forms/employee_collate_objective`,
        params
      ).then((res) => {
        if (res.employee_collate_objective) {
          setTotalCount(res["total_count"]);
          let CoachinRates = res.employee_collate_objective;
          setCAFList(CoachinRates);

          setLoading(false);
        }
      });
    }
  };
  useEffect(() => {
    if (filterDataState[0]?.startDate && filterDataState[0]?.endDate) {
      setOrganizationLoader(true);
      // fetchAssignments();
      // fetchService();
    }
    if (filterDataState[0]?.startDate !== filterDataState[0]?.endDate) {
      setAnchorElPicker(null);
    }
  }, [filterDataState]);

  const handleClickPicker = (event) => {
    setAnchorElPicker(event.currentTarget);
  };

  const handleClosePicker = () => {
    setAnchorElPicker(null);
  };

  const openPicker = Boolean(anchorElPicker);
  const id = open ? "simple-popover" : undefined;
  useEffect(() => {
    setLoading(true);
    CoachinRate();
    // setRefresh(!refresh)
  }, [page, pageSize, value, filterDataState, userData]);

  const globaluserData = useSelector(state => state.commonReducer)
  let role = globaluserData?.role
  // let role = sessionStorage.getItem("role");
  let organisationName = sessionStorage.getItem("organisation_name");

  const onChangeItem = (selectedItemValue, e) => {
    setUserData({
      ...userData,
      [selectedItemValue.id]: selectedItemValue.value,
    });

    if (selectedItemValue.value === "Custom date") {
      setPopover("view_more");
    } else {
      setPopover("");
    }
  };
  // const sortByArray = [
  //   { id: 1, value: "external", name: 'external' },
  //   { id: 2, value: "internal", name: 'internal' },
  // ];
  const sortByArray = [
    { id: "external", name: "external", value: "External" },
    { id: "internal", name: "internal", value: "Internal" },
  ];
  const handleItemClick = (item) => {
    //Redirect to new route from here with the item data
    // const selectedRow = item;
    // setCurrentSelection(selectedRow);
    // console.log(
    //   "currentSelection :>> ",
    //   currentSelection,
    //   selectedRow.assignment_id
    // );
    // setAction("view_summary");
    // const queryParams = new URLSearchParams(location1.search);

    // if (queryParams.has("error")) {
    //   queryParams.delete("error");
    //   history.replace({
    //     search: queryParams.toString(),
    //   });
    // }

    // selectedRow..map(row=>(
      console.log('itemitem :>> ', item);
    history.push({
      pathname: "/assignmentsummary",
      state: {
        currentAssignment: {
          id: item,
          
        },
      }
      // state: { currentAssignment: item },
    });
    // ))
  };

  return (
    <div className={classes.wrapper}>
      <Typography variant='subtitle2' color='secondary'>
        {/* Coaching Rate Card */}
      </Typography>
      {role !== "admin" ? (
        <React.Fragment>
          <Typography
            variant='subtitle1'
            color='secondary'
            style={{ marginTop: 15 }}
          >
            <Box mb={1} fontWeight='fontWeightBold'>
              {/* Organisation name - {organisationName} */}
            </Box>
          </Typography>
          <Grid container direction='row'>
            <Grid item xs={12}>
              <Grid container direction='row' spacing={2}>
                <Grid item xs={2.5}>
                  <Typography variant='subtitle1'>
                    <Box mb={1} color={"#EF7000"}>
                      Service
                    </Box>
                  </Typography>

                  <Autocomplete
                    // value={value}
                    onChange={(event, newValue) => {
                      if (newValue === null) {
                        newValue = "";
                      }
                      // setValue(newValue);
                      setUserData({
                        ...userData,
                        service_type_id: newValue.id,
                      });
                    }}
                    inputValue={inputValue2}
                    onInputChange={(event, newInputValue) => {
                      setInputValue2(newInputValue);
                    }}
                    id='controllable-states-demo'
                    options={sortByArray}
                    getOptionLabel={(option) => option.value}
                    style={{ width: 260 }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        classes={{ root: classes.customTextField }}
                        inputProps={{
                          ...params.inputProps,
                          style: {
                            fontSize: "16px",
                            padding: "2px !important",
                          },
                        }}
                        placeholder='Select service'
                        InputLabelProps={{
                          style: { fontSize: "16px", fontFamily: "Open Sans" },
                        }}
                        autoFocus
                        variant='outlined'
                      />
                    )}
                  />
                </Grid>
                <Grid item xs={2.5}>
                  <Typography variant='subtitle1'>
                    <Box mb={1} color={"#EF7000"}>
                      Service type
                    </Box>
                  </Typography>

                  <Autocomplete
                    // value={value}
                    onChange={(event, newValue) => {
                      if (newValue === null) {
                        newValue = "";
                      }
                      // setValue(newValue);
                      setUserData({
                        ...userData,
                        service_type: newValue.id,
                      });
                    }}
                    inputValue={inputValue3}
                    onInputChange={(event, newInputValue) => {
                      setInputValue3(newInputValue);
                    }}
                    id='controllable-states-demo'
                    options={serviceType}
                    getOptionLabel={(option) => option.value}
                    style={{ width: 260 }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        classes={{ root: classes.customTextField }}
                        inputProps={{
                          ...params.inputProps,
                          style: {
                            fontSize: "16px",
                            padding: "2px !important",
                          },
                        }}
                        placeholder='Select service type'
                        InputLabelProps={{
                          style: { fontSize: "16px", fontFamily: "Open Sans" },
                        }}
                        autoFocus
                        variant='outlined'
                      />
                    )}
                  />
                </Grid>
                <Grid item xs={2.5}>
                  <Typography variant='subtitle1'>
                    <Box mb={1} color={"#EF7000"}>
                      Business unit
                    </Box>
                  </Typography>
                  <Autocomplete
                    // value={value}
                    onChange={(event, newValue) => {
                      if (newValue === null) {
                        newValue = "";
                      }
                      // setValue(newValue);
                      setUserData({
                        ...userData,
                        business_unit_id: newValue.id,
                      });
                    }}
                    inputValue={inputValue}
                    onInputChange={(event, newInputValue) => {
                      setInputValue(newInputValue);
                    }}
                    id='controllable-states-demo'
                    options={businessUnit}
                    getOptionLabel={(option) => option.value}
                    style={{ width: 260 }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        classes={{ root: classes.customTextField }}
                        inputProps={{
                          ...params.inputProps,
                          style: {
                            fontSize: "16px",
                            padding: "2px !important",
                          },
                        }}
                        placeholder='Select business unit'
                        InputLabelProps={{
                          style: { fontSize: "16px", fontFamily: "Open Sans" },
                        }}
                        autoFocus
                        variant='outlined'
                      />
                    )}
                  />
                  {/* <CustomSelect
                    id="business_unit_id"
                    name="business_unit_id"
                    displayEmpty
                    labelText="Select business unit"
                    variant="outlined"
                    itemArr={businessUnit.map((el) => el.value)}
                    parentcall={onChangeItem}
                  /> */}
                </Grid>
                <Grid item xs={2.5}>
                  <Typography variant='subtitle1'>
                    <Box mb={1} color={"#EF7000"}>
                      Location
                    </Box>
                  </Typography>
                  {/* <Select
                    labelId="master_template_id"
                    id="master_template_id"
                    name="master_template_id"
                    placeholder={"Choose From Master Template"}
                    //   onChange={(obj) => {
                    //     obj.target.value && onChangeItem(`attendees`, index, obj.target.value)
                    // }}
                    onChange={onChangeItem}
                    variant="outlined"
                
                    
                    style={{ width: "100%" }}
                  >
                    {location?.map((data) => {
                      return (
                        <MenuItem name={data?.id} value={data?.id}>
                          <Typography variant="h2">{data?.value}</Typography>
                        </MenuItem>
                      );
                    })}
                  </Select> */}
                  <Autocomplete
                    // value={value}
                    onChange={(event, newValue) => {
                      if (newValue === null) {
                        newValue = "";
                      }
                      setUserData({
                        ...userData,
                        location_id: newValue.id,
                      });
                    }}
                    inputValue={inputValue1}
                    onInputChange={(event, newInputValue) => {
                      setInputValue1(newInputValue);
                    }}
                    ListboxProps={{ style: { maxHeight: 150 } }}
                    id='controllable-states-demo'
                    options={location}
                    getOptionLabel={(option) => option.value}
                    style={{ width: 230 }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        classes={{ root: classes.customTextField }}
                        inputProps={{
                          ...params.inputProps,
                          style: {
                            fontSize: "16px",
                            padding: "2px !important",
                          },
                        }}
                        placeholder='Select location'
                        InputLabelProps={{
                          style: { fontSize: "16px", fontFamily: "Open Sans" },
                        }}
                        autoFocus
                        variant='outlined'
                      />
                    )}
                  />
                  {/* <CustomSelect
                    id="location_id"
                    name="location_id"
                    labelText={"Select location"}
                    displayEmpty
                    variant="outlined"
                    itemArr={location.map((el) => el.value)}
                    parentcall={onChangeItem}
                  /> */}
                </Grid>
                <Grid item xs={2}>
                  <Typography variant='subtitle1'>
                    <Box mb={1} color={"#EF7000"}>
                      Date
                    </Box>
                  </Typography>
                  <CustomSelect
                    id='filter'
                    displayEmpty
                    labelText={"Select date"}
                    variant='outlined'
                    itemArr={["Last 6 months", "Last 12 months", "Custom date"]}
                    parentcall={onChangeItem}
                  />
                  {/* <Select
                    labelId="filter"
                    id="filter"
                    name="filter"
                      onChange={(obj) => {
                        obj.target.value && onChangeItem(`filter`, obj.target.value)
                    }}
                    // onChange={onChangeItem}
                    variant="outlined"
                    hideLable
                    style={{ width: "100%" }}
                  >
                           <MenuItem value={"Last 6 months"}>Last 6 months</MenuItem>
          <MenuItem value={"Last year"}>Last year</MenuItem>
          <MenuItem value={"Custom date"}>Custom date</MenuItem>

                  </Select> */}
                </Grid>
                <Grid item xs={2}>
                  <Typography variant='subtitle1'>
                    <Box mb={1} color={"#EF7000"}>
                      Sort by
                    </Box>
                  </Typography>
                  {/* <Select
                   
                    id="sort_by"
                    name="sort_by"
                      onChange={(obj) => {
                        obj.target.value && onChangeItem(`sort_by`, obj.target.value)
                    }}
                    // onChange={onChangeItem}
                    variant="outlined"
                    hideLable
                    style={{ width: "100%" }}
                  >
                           <MenuItem value={"Latest"}>Latest</MenuItem>
          <MenuItem value={"Oldest"}>Oldest</MenuItem> */}

                  {/* </Select> */}
                  <CustomSelect
                    id='sort_by'
                    labelText='Select sort by'
                    displayEmpty
                    variant='outlined'
                    itemArr={["Latest", "Oldest"]}
                    parentcall={onChangeItem}
                    // defaultValue={userData.sortBy}
                  />
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </React.Fragment>
      ) : (
        <Grid container direction='row' spacing={2}>
          <Grid item xs={6}>
            <Typography
              variant='subtitle1'
              color='secondary'
              style={{ marginTop: 15 }}
            >
              <Box mb={1} fontWeight='fontWeightBold'>
                Select organization
              </Box>
            </Typography>
            {/* <CustomSelect
                  id="organisation"
                  labelText="Select Organisation"
                  displayEmpty
                  variant="outlined"
                  itemArr={["All", ...orgData.map((option) => option.organisation_name)]}
                  parentcall={onChangeItem}
                  defaultValue={userData.organisation}
                /> */}
            {/* <InputBase
                fullWidth
                style={{
                  height: 50,
                  paddingLeft: 10,
                  fontSize: "16px",
                  fontFamily: "Open Sans",
                }}
                placeholder="Search anything"
                value={searchTextSelect}
                onChange={(e) => handleSearchText(e.target.value)}
                startAdornment={
                  <InputAdornment position="start">
                    <SearchIcon />
                  </InputAdornment>
                }
              /> */}
            {/* <div className={classes.wrapper1}>
        <Popper
          style={{ zIndex: "1500" }}
          open={open}
          anchorEl={anchorRef.current}
          role={undefined}
          transition
          disablePortal
        ></Popper>
        <InputBase
          fullWidth
          style={{
            height: 50,
            paddingLeft: 10,
            fontSize: "16px",
            fontFamily: "Open Sans",
          }}
          placeholder={"Search anything"}
          value={searchTextSelect}
          onChange={(e) => handleSearchText(e.target.value)}
          startAdornment={
            <InputAdornment position="start">
              <SearchIcon />
            </InputAdornment>
          }
        />
      </div> */}
            <Autocomplete
              value={value}
              onChange={(event, newValue) => {
                if (newValue === null) {
                  //Just give a value to a value to avoid null
                  //e.g. value = ""
                  newValue = "";
                }
                setValue(newValue);
              }}
              // classes={{
              //     input: classes.autoComplete,
              //     option: classes.autoComplete
              // }}

              inputValue={orgValue}
              onInputChange={(event, newInputValue) => {
                setOrgValue(newInputValue);
              }}
              id='controllable-states-demo'
              options={orgData}
              getOptionLabel={(option) => option.organisation_name}
              style={{ width: 280 }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  classes={{ root: classes.customTextField }}
                  inputProps={{
                    ...params.inputProps,
                    style: { fontSize: "16px" },
                  }}
                  placeholder='Organization name'
                  InputLabelProps={{
                    style: { fontSize: "16px", fontFamily: "Open Sans" },
                  }}
                  autoFocus
                  variant='outlined'
                />
              )}
            />
            {/* <Autocomplete
            value={value}
            onChange={(event, newValue) => {
              if (newValue === null) {
                //Just give a value to a value to avoid null
                //e.g. value = ""
                newValue = "";
              }
              setValue(newValue);
            }}
            classes={{
              input: classes.autoComplete,
              option: classes.autoComplete,
            }}
            inputValue={inputValue}
            onInputChange={(event, newInputValue) => {
              setInputValue(newInputValue);
            }}
            id="controllable-states-demo"
            options={orgData}
            getOptionLabel={(option) => option.organisation_name}
            // style={{ width: 280 }}
            renderInput={(params) => (
              <TextField
                {...params}
                classes={{ root: classes.customTextField }}
                inputProps={{
                  ...params.inputProps,
                  style: { fontSize: "16px", height: '1px', fontFamily: 'Open Sans' },
                }}
                placeholder="Organization name"
                autoFocus
                variant="outlined"
              />
            )}
          /> */}
          </Grid>
        </Grid>
      )}
      <div className={classes.datepickerPopover}>
        {openPopover === "view_more" && (
          <Button
            aria-describedby={id}
            variant='contained'
            onClick={handleClickPicker}
          >
            {filterDataState[0]?.startDate
              ? moment(filterDataState[0]?.startDate).format("Do MMM YYYY")
              : "DD MM YYYY"}{" "}
            -{" "}
            {filterDataState[0]?.endDate
              ? moment(filterDataState[0]?.endDate).format("Do MMM YYYY")
              : "DD MM YYYY"}
          </Button>
        )}
        {openPopover === "view_more" && (
          <Popover
            id={id}
            open={openPicker}
            anchorEl={anchorElPicker}
            onClose={handleClosePicker}
            anchorOrigin={{
              vertical: "bottom",
              horizontal: "center",
            }}
            transformOrigin={{
              vertical: "center",
              horizontal: "center",
            }}
          >
            <DateRange
              className={classes.datePicker}
              editableDateInputs={true}
              onChange={(item) => setFilterDataState([item.selection])}
              moveRangeOnFirstSelection={false}
              ranges={filterDataState}
            />
          </Popover>
        )}
      </div>
      {
        <Grid container direction='row' spacing={2}>
          <TableContainer
            style={{ marginTop: "40px" }}
            className={classes.container}
          >
            <Table stickyHeader aria-label='sticky table'>
              <TableHead>
                <TableRow>
                  {columns.map((column) => (
                    <TableCell key={column.id}>{column.label}</TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {CAFList.length > 0 &&
                  CAFList.map((item, index) => {
                    return (
                      <React.Fragment>
                        {CAFList[index].objectives.length > 0 &&
                          CAFList[index].objectives.map((row) => {
                            return (
                              <TableRow
                                hover
                                role='checkbox'
                                tabIndex={-1}
                                key={row.code}
                              >
                                {columns.map((column) => {
                                  const value = row[column.id];
                                  const val = item[column.id];
                                  return (
                                    <React.Fragment>
                                      {column.id === "organisation_metric" ? (
                                        <TableCell
                                          style={{ verticalAlign: "top" }}
                                          key={column.id}
                                        >
                                          {val}
                                        </TableCell>
                                      ) : column.id === "view_summary" ? (
                                        <TableCell>
                                          {row.assignments !== undefined &&
                                            row.assignments.length > 0 &&
                                            row.assignments.map((test) => (
                                              <Button
                                                style={{
                                                  color: "rgb(239, 112, 0)",
                                                }}
                                                onClick={() =>
                                                  handleItemClick(test.id)
                                                }
                                              >
                                                {" "}
                                                {test.value}{" "}
                                              </Button>
                                            ))}
                                        </TableCell>
                                      ) : (
                                        <React.Fragment>
                                          <TableCell
                                            style={{ verticalAlign: "top" }}
                                            key={column.id}
                                          >
                                            {value}
                                          </TableCell>
                                        </React.Fragment>
                                      )}
                                    </React.Fragment>
                                  );
                                })}
                              </TableRow>
                            );
                          })}
                      </React.Fragment>
                    );
                  })}
              </TableBody>
            </Table>
          </TableContainer>
        </Grid>
      }
      {/* { (
        <Popover
          anchorOrigin={{
            vertical: "center",
            horizontal: "left",
          }}
          transformOrigin={{
            vertical: "center",
            horizontal: "left",
          }}
          open={openPopover === "view_more"}
          anchorEl={anchorEl}
          onBackdropClick={() => setPopover(null)}
        >
          <div>
            <Typography
              style={{
                padding: "5px 0 5px 15px",
              }}
              variant="h2"
              color="secondary"
            >
              {currentSelection.module_name}
            </Typography>
          </div>
        </Popover>
      )} */}
    </div>
  );
}
